const CONFIG_FIELDS = [
  ["branding.app_name", "App Name", "text"],
  ["branding.primary_color", "Primary Color", "text"],
  ["branding.secondary_color", "Secondary Color", "text"],
  ["mobile.app_store_url", "App Store URL", "url"],
  ["mobile.play_store_url", "Play Store URL", "url"],
  ["mobile.deep_link_base_url", "Deep Link Base URL", "text"],
  ["mobile.support_url", "Support URL", "url"],
  ["app.currency", "Currency", "text"],
  ["app.facebook_url", "Facebook URL", "url"],
  ["app.instagram_url", "Instagram URL", "url"],
  ["app.whatsapp_link", "WhatsApp Link", "text"],
  ["app.contact_email", "Contact Email", "text"],
  ["app.contact_phone", "Contact Phone Number", "text"],
];

const CURRENCY_AND_LOCALE = [
  { locale: "fi-FI", currency: "EUR" },
  { locale: "da-DK", currency: "DKK" },
];
export const createEmptyTenantConfig = () =>
  CONFIG_FIELDS.reduce((config, [key]) => {
    config[key] = "";
    return config;
  }, {});

export const compactTenantConfig = (config) =>
  Object.fromEntries(
    Object.entries(config).filter(
      ([, value]) => value !== null && value !== undefined && value !== "",
    ),
  );

const TenantConfigFields = ({ config, onChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {CONFIG_FIELDS.map(([key, label, type]) => (
        <div key={key} className="relative w-full">
          <label className="block uppercase text-slate-600 text-xs font-bold mb-2">
            {label}
          </label>
          {key === "app.currency" ? (
            <select
              className="border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              onChange={(e) => onChange(key, e.target.value)}
            >
              {CURRENCY_AND_LOCALE.map((item) => (
                <option
                  key={item.locale}
                  value={JSON.stringify(item)}
                  selected={
                    config[key]
                      ? JSON.parse(config[key]).locale === item.locale
                      : "false"
                  }
                >
                  {item.currency}
                </option>
              ))}
            </select>
          ) : (
            <input
              type={type}
              aria-label={label}
              className="border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              value={config[key] ?? ""}
              onChange={(e) => onChange(key, e.target.value)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default TenantConfigFields;
